import Management from '../svgs/manage.svg';
import Resources from '../svgs/setting.svg';
import Notifications from '../svgs/notifications.svg';
import InfoSection from '../components/info_section';
import ScrollButton from '../components/scroll_button';
import Layout from '../components/layout';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import styles from '../styles/projects.module.scss';
import Image from 'next/image';
import RelatedServices from '../components/relatedServices';
import DevOps from '../public/devops.svg';
import Outrun from '../public/outrun.svg';

const relatedServices = [
  {
    title: 'ICDC DevOps',
    img: DevOps,
    link: '/devops'
  },
  {
    title: 'ICDC Outrun Cloud',
    img: Outrun,
    link: '/storage'
  }
];

export default function Projects () {
  const router = useRouter();
  const { t } = useTranslation('projects');

  return (
    <Layout title={t('title')} lang={router.locale} route={router.route} isHeader isFooter>
			<ScrollButton scrollStepInPx='50' delayInMs='16.66'/>

      <InfoSection className='projects' title='Projects' description='projectsDescription' documentationLink='https://help.icdc.io/projects/' lang={router.locale} />

      <section className={styles.get_started}>
        <div className={styles.get_started_content}>
          <div className={styles.img_container}>
            <Image src='/newProjects.webp' alt='Projects' width={637} height={463} unoptimized loading='lazy' />
          </div>
          <div className={styles.projects_content}>
            <h2>{t('get_started')}</h2>
            <p>{t('get_staerted_desc')}</p>
          </div>
        </div>
      </section>

      <section className={styles.features_section}>
        <div className={styles.projects__features}>
            <div className={styles.flex}>
            <Image src={Resources} alt="" loading='lazy' />
                <div>
              <h3>{t('resources')}</h3>
                  <p>{t('resources_desc')}</p>
                </div>
            </div>
            <div className={styles.flex}>
            <Image src={Management} alt="" loading='lazy' />
                <div>
              <h3>{t('management')}</h3>
                  <p>{t('management_desc')}</p>
                </div>
            </div>
            <div className={styles.flex}>
            <Image src={Notifications} alt="" loading='lazy' />
                <div>
              <h3>{t('notifications')}</h3>
                  <p>{t('notifications_desc')}</p>
                </div>
            </div>
        </div>
      </section>

      <section className={styles.get_started}>
        <div className={styles.get_started_content}>
          <div className={styles.quotas_content}>
            <h2>{t('quotas_title')}</h2>
            <p>{t('quotas_desc')}</p>
          </div>
          <div className={styles.img_container}>
            <Image src='/newQuotas.webp' alt='Projects' width={637} height={532} unoptimized loading='lazy' />
          </div>
        </div>
      </section>

      <RelatedServices services={relatedServices} />
    </Layout>

	);
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['projects', 'common']),
  },
});
